<app-dialog-container
  title="{{ 'cart' | translate }}"
  [showCancelButton]="false"
  [showConfirmButton]="false"
>
  <app-cart-content variant="modal" (closeRequested)="close()"></app-cart-content>
</app-dialog-container>
